import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sales-report-chart" }
const _hoisted_2 = { class: "chart-header" }
const _hoisted_3 = { class: "chart-controls" }
const _hoisted_4 = { class: "chart-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_v_chart = _resolveComponent("v-chart")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_alert = _resolveComponent("a-alert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_a_radio_group, {
          value: _ctx.chartType,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.chartType) = $event)),
          size: "small",
          "button-style": "solid"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_radio_button, { value: "line" }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("折线图", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_a_radio_button, { value: "bar" }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("柱状图", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"]),
        _createVNode(_component_a_select, {
          value: _ctx.timeRange,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.timeRange) = $event)),
          options: _ctx.timeRangeOptions,
          style: {"width":"120px","margin-left":"8px"},
          size: "small"
        }, null, 8, ["value", "options"])
      ])
    ]),
    _createVNode(_component_a_spin, { spinning: _ctx.loading }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "chart-container",
          style: _normalizeStyle({ height: `${_ctx.height}px` })
        }, [
          _createVNode(_component_v_chart, {
            option: _ctx.chartOption,
            autoresize: ""
          }, null, 8, ["option"])
        ], 4)
      ]),
      _: 1
    }, 8, ["spinning"]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.showAverage)
        ? (_openBlock(), _createBlock(_component_a_alert, {
            key: 0,
            message: `平均销售额: ${_ctx.averageSales} 元`,
            type: "info",
            banner: ""
          }, null, 8, ["message"]))
        : _createCommentVNode("", true)
    ])
  ]))
}